module.exports = __webpack_public_path__ + "static/media/discord_manager.d7953e2a.png";